<template>
    <div class="modal fade" id="viewAppointmentLetterContract">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printAppointmentLetterContract()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printAppointmentLetterContract">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><strong>Appointment Letter- Contract</strong></h4></td>
                          <td class="text-right" width="20%" v-if="seeRecord.user"><barcode v-bind:value="seeRecord.user.code" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <table class="table" v-if="seeRecord.user" >
                        <thead>
                          <td>
                            <b>
                              {{seeRecord.user.name}} <br>
                              <i>{{seeRecord.address}},</i><br> <i>{{seeRecord.city}},</i><i v-if="seeRecord.state">{{seeRecord.state.name}} -</i>  <i>{{seeRecord.pin}}</i><br>
                            </b>
                          </td>
                          <td class="text-right" v-if="seeRecord.branch">Branch: {{seeRecord.branch.name}} <br>Date: {{currDate | myDate}}</td>
                        </thead>
                      </table>
                      <p class="text-center text-bold">Sub: Consultancy Assignment</p>
                      <p>Dear <b v-if="seeRecord.user">{{seeRecord.user.name}}</b></p>
                      <p>This has reference to your application and subsequent interviews you have had with us. We are pleased to offer you a Consultancy assignment in our {{getCompanyRecord.companyName}} based at <i v-if="seeRecord.branch">Branch: {{seeRecord.branch.name}}</i>, with effect from {{seeRecord.joiningDate | myDate}}, on the following terms and conditions.</p>
                      <p>The Company undertakes Loan disbursement, loan collection and EMI recovery at various locations and you are being engaged for the same, based at <i v-if="seeRecord.branch">{{seeRecord.branch.address}},</i> on the following terms & conditions:</p>
                      <p class="text-bold">Scope of Work</p>
                      <p>You will be responsible for:</p>
                      <p>Management reserves the right of changing the scope of your work or your posting based on business exigencies.</p>
                      <p class="text-bold">A.	Terms</p>
                      <ul>
                        <li>This contract will be valid for {{contracttenure}} with effect from {{seeRecord.joiningDate | myDate}}.</li>
                        <li>You would be paid monthly consultancy fees of Rs.{{consultancyfees}}</li>
                        <li>Inland Travel: You will be entitled for Rs.{{travelfare}}. You would stay at company transit houses wherever available.You would be paid a daily boarding allowance of Rs.{{travelfare}}/- from which expenses towards meals would be deducted. If you stay with relatives or friends you would be paid an additional amount. .  If required to stay in hotel the daily limit for reimbursement.  </li>
                        <li>You would be reimbursed the cost of any official long distance calls made by you upon submission of bills.</li>
                        <li>You are expected to work for 313 days in a year (exclusive of public holidays & festivities) and you should inform your non availability in advance.</li>
                        <li>During the course of your employment with {{getCompanyRecord.companyName}}, you will be required to abide by {{getCompanyRecord.companyName}}, code of conduct as detailed out in Annexure A.  Non-compliance to the code of conduct will lead to termination without notice and the management may (depending on the nature of violation) proceed with legal lawsuit.</li>
                      </ul>
                      <p>The contract may be terminated with one month’s notice from either side or on payment of one months salary</p>
                      <p class="text-bold">B. Confidentiality of Information</p>
                      <p>1.	You will not divulge information about the company, customer, and progress of the project to any outsider without prior approval from your supervising manager.</p>
                      <p>2.	You will not undertake similar assignments from competitors of the {{getCompanyRecord.companyName}}, during the course of this contract.</p>
                      <p>You will take utmost care during the course of this contract in handling business information of sensitive nature to maintain its secrecy.</p>
        
                      <p class="text-bold">C. Reporting</p>
                      <p>You are required to inform the progress of your work to {{reportingmanager}}</p>
                      <p>Kindly communicate your acceptance of this contract by signing a copy of this letter and returning it to us.</p>
                      <p>Thanking you.</p>
                      <p>Sincerely, </p><br>
                      <p>For <b>{{getCompanyRecord.companyName}}</b></p>
                      <p>Managing Director</p>
                      <p>CC: Accounts Manager</p>
                      <p>Accepted by <b v-if="seeRecord.user">{{seeRecord.user.name}}</b></p><br><br>
                      <p>Signature of the Candidate</p>
                      <p>Date: </p>
                      <p>Location: </p>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'PropsTesting',
  data () {
    return {
      currDate: new Date()
    }
  },
  methods: {
    printAppointmentLetterContract () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printAppointmentLetterContract').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    contracttenure: '',
    reportingmanager: '',
    consultancyfees: '',
    travelfare: '',
    logo: '',
    getCompanyRecord: {}
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentLetterContract.vue?c3fad91c